import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type {
    IServiceGraderPoolOption,
    IServiceOrganizationSettingFormSectionProps,
} from '../ServiceOrganizationSetting';
import { ServiceType } from '../../../../../../common/enums/serviceType';
import { translateKey } from '../../../../../translate';
import { DropdownField } from '../../../../fields/Dropdown';
import { ServiceOrganizationSettingFormMode } from '../ServiceOrganizationSetting';

interface IServiceGraderPoolFormSectionProps extends IServiceOrganizationSettingFormSectionProps {
    serviceGraderPools: IServiceGraderPoolOption[];
}

export function GraderPoolFormSection(props: IServiceGraderPoolFormSectionProps) {
    if (!showGraderPoolFormSection()) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceGraderPool.serviceGraderPool')}>
            <FormGroup label={translateKey('serviceGraderPool.serviceGraderPool')}>
                {props.mode === ServiceOrganizationSettingFormMode.read ? (
                    <FormParagraph>{props.serviceGraderPool.name || '-'}</FormParagraph>
                ) : (
                    <DropdownField
                        error={props.errors.get('serviceGraderPoolId')}
                        label=""
                        newstyles
                        onChange={(value) => props.handleChange('serviceGraderPoolId', value)}
                        onDoValidate={async () => await props.validateOne('serviceGraderPoolId')}
                        selectOptions={getOptions()}
                        value={props.serviceGraderPoolId}
                    />
                )}
            </FormGroup>
        </FormSection>
    );

    function showGraderPoolFormSection() {
        return (
            props.service.serviceType === ServiceType.examination &&
            props.hasBiometricians &&
            props.serviceGraderPools.length > 0
        );
    }

    function getOptions() {
        return [{ value: '', text: translateKey('serviceGraderPool.selectServiceGraderPool') }].concat(
            [...props.serviceGraderPools].map((item) => ({ value: item.id, text: item.name }))
        );
    }
}
